/**
 * Domain definitions for Career Constellation
 * These represent the five core psychological domains
 */
/**
 * Single source of truth for the five domain accent colors.
 * Harmonized to the APC cohort landing palette (mirrors --domain-* in
 * cosmic-design-tokens.css). Used for SVG/canvas fills where CSS var() cannot
 * resolve, so these must stay in sync with the CSS tokens.
 */
export const DOMAIN_COLORS = {
  insight: '#2DA3CB',    // Blue
  vision: '#10b981',     // Green
  connection: '#f39c12', // Gold
  impact: '#f15a24',     // Orange
  structure: '#54548E'   // Purple
};

const domains = [
  {
    id: 'insight',
    name: 'Insight',
    color: DOMAIN_COLORS.insight,
    coreQuestion: 'How do you understand the world?',
    psychologicalDriver: 'Processing information, analyzing patterns, and creating understanding'
  },
  {
    id: 'connection',
    name: 'Connection',
    color: DOMAIN_COLORS.connection,
    coreQuestion: 'How do you relate to others?',
    psychologicalDriver: 'Building relationships, understanding people, and creating meaningful interactions'
  },
  {
    id: 'vision',
    name: 'Vision',
    color: DOMAIN_COLORS.vision,
    coreQuestion: 'How do you conceptualize possibilities?',
    psychologicalDriver: 'Imagining futures, creating meaning, and seeing potential'
  },
  {
    id: 'structure',
    name: 'Structure',
    color: DOMAIN_COLORS.structure,
    coreQuestion: 'How do you organize and implement?',
    psychologicalDriver: 'Creating order, establishing processes, and ensuring reliability'
  },
  {
    id: 'impact',
    name: 'Impact',
    color: DOMAIN_COLORS.impact,
    coreQuestion: 'How do you make things happen?',
    psychologicalDriver: 'Taking action, influencing outcomes, and driving results'
  }
];

export default domains; 
